import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ModuleLoader } from '@wix/thunderbolt-renderer-utils'
import { PromiseCacheSymbol, ImportMapSymbol } from './symbols'
import type { IPromiseCache, ImportMap } from './types'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'

export const ESMLoaderFactory = withDependencies(
	[PromiseCacheSymbol, ImportMapSymbol, BrowserWindowSymbol],
	(promiseCache: IPromiseCache, importMap: ImportMap, browserWindow: BrowserWindow): ModuleLoader => {
		const scriptsCache: Record<string, any> = {}
		return {
			prefetchScript: (_url) => {
				// not implemented for esm
			},
			loadModule: async (url) => {
				importMap.commitImportMapUpdates()

				const cached = scriptsCache[url]
				if (cached) {
					return cached
				}

				return promiseCache.runWithCache(url, async () => {
					// if importShim is available, this means the shim has run so we need to use it
					const dynamicImport = browserWindow?.importShim ?? ((url: string) => import(/* webpackIgnore: true */ url))

					const module = await dynamicImport(url)

					scriptsCache[url] = module
					return module
				})
			},
		}
	}
)
